import * as React from 'react';
import Page from '@src/layout-components/page';
import TopicHero from '@src/ui-components/topic-hero';
import useStore from '@src/utils/hooks/use-store';
import MainStore from './store';

const styles = require('./index.less');

const Main = () => {
  useStore(() => new MainStore());
  return (
    <Page className={styles.root}>
      <TopicHero />
    </Page>
  );
};

export default Main;
